
import cn from 'classnames';
import styles from './styles.module.scss';

export default function InputLabel({ small = false, animation = false, black = false, fontSize, children, ...props }) {
  return (
    <span
      className={cn(
        styles.input_label,
        black && styles.input_label_black,
        small && styles.input_label_small,
        animation && styles.label_animation,
        props.styles,
      )}
      style={{ ...props.style, fontSize }}
    >
      {children}
    </span>
  );
}
